export enum BlogStatus {
  PUBLISH = "publish",
  UNPUBLISH = "unpublish",
}

export enum Gender {
  MALE = 0,
  FEMALE = 1
}

export type BlogOutputModel = {
  id: string;
  title: string;
  content: string; 
  description: string | null; 
  status: BlogStatus;
  link: string;
  imageTitle: string | null;
  imageCaption: string | null;
  imageDescription: string | null;
  imageAltText: string | null;
  imageFeatured: string | null;
  labels: LabelsOutputModel[];
  categories: BlogCategoryOutputModel[];
  author: string;
  // authors: BlogAuthorOutputModel[];
  avatar: string | null;
  code: string;
  isPublish: boolean;
  publishDate: string | null;
  isEditSEO: boolean;
  titleSEO: string;
  descriptionSEO: string;
  languageId: string;
  alt: string | null;
  shortDescription: string | null;
};

export type BlogCategoryOutputModel = {
  id: string;
  categoryId: string;
  resourceId: string;
};

export type BlogAuthorOutputModel = {
  id: string;
  authorId: string;
  resourceId: string;
  authorInformation: BlogAuthorApiOutputModel;
};

export type BlogAuthorApiOutputModel = {
  id: string;
  fullName: string;
  avatar: string | null;
  email: string | null;
  gender: Gender;
  phone: string | null;
};

export type BlogCategoryApiOutputModel = {
  id: string;
  languageId: string;
  title: string;
  link: string;
  code: string;
  status: string;
  type: string;
};

export type LabelsOutputModel = {
  id : string;
  labelId : string;
  resourceId : string;
  labelInformation: AllLabelOutputModel;
}

export type AllLabelOutputModel = {
  id: string;
  name: string;
}

// {
//     "id": "caab1a6f-8e4e-4816-831d-d1d909d26f99",
//     "categoryBlogId": "a5e808f3-5d1d-4748-92a9-14261b0cefe1",
//     "title": "Quà tết ý nghĩa cho ông bà",
//     "pageTitle": "string",
//     "content": "<p><strong><em>Mua rượu vang ở đâu</em></strong><em> giữa thời buổi kinh tế thị trường, hàng loạt các cá nhân, đơn vị phân phối rượu đang phân phối hàng trăm, hàng ngàn loại rượu vang. Tất cả đều khiến cho những người có nhu cầu mua rượu như rơi vào một ma trận. Hàng loạt những lời mời chào, giữa một mê cung giá cả, màu sắc, thương hiệu, hương vị. Rất nhiều người đã từ bỏ việc tìm câu trả lời cho câu hỏi: “Mua rượu vang ở đâu” bởi lẽ đã quá mệt mỏi khi phân vân trước quá nhiều lựa chọn.</em></p><p>Trong bài biết sau đây, chúng tôi sẽ “<em>gỡ rối</em>” cho các bạn vấn đề phải mua rượu vang ở đâu để an tâm về chất lượng và giá cả hợp lý, cũng như các tiêu chí lựa chọn rượu hoàn hảo nhất.</p><p class=\"ql-align-center\"><img src=\"https://winemartvn.com/api/uploads/posts/fc468fd33c9c0d0975897b31744d7b04.jpg\"></p><h2><strong>Mua rượu vang ở đâu và những vấn đề cần cân nhắc khi mua</strong></h2><p>Hiện nay, việc mua bán đã dần chuyển sang hướng trực tuyến, có thể nói: “<em>Chỉ cần đủ tiền, bạn chỉ việc ngồi một chỗ mà có thể mua mọi thứ trên đời</em>”. Rượu vang cũng không phải là ngoại lệ, thế nên việc <strong>mua rượu vang ở đâu</strong> cũng không còn quan trọng nữa. Điều quan trọng ở đây là mua từ ai và nếu vậy thì giá là bao nhiêu?</p><p class=\"ql-align-center\"><img src=\"https://winemartvn.com/api/uploads/posts/f9522bfa81ef5219232d75c4413f90fe.jpg\"></p><p><br></p><p>Mua rượu vang ở đâu? Từ ai? Là điều đầu tiên bạn cần phải cân nhắc đến. Dạo quanh một vòng thị trường tìm nơi mua rượu, hoặc ngồi tìm kiếm thông tin về những nơi bán rượu vang uy tín, bạn có thể liệt kê ra một vài cá nhân đơn vị phân phối rượu vang, phân thành 4 nhóm như sau:</p><p>- Rượu Vang tại các siêu thị lớn: Có thể an tâm phần nào về chất lượng. Tuy nhiên, có quá ít sự lựa chọn, nhân viên thì ít kiến thức về rượu, còn bạn - nếu không phải một tay sành rượu, thì cũng không biết phải mua loại nào. Siêu thị - đúng như tên gọi của nó, là một cái chợ siêu lớn, đủ thứ mặt hàng. Người đi chợ đôi lúc chỉ có thể dựa vào kinh nghiệm ít ỏi của mình, với hi vọng mong manh sẽ lựa chọn được món hàng phù hợp.</p><p class=\"ql-align-center\"><img src=\"https://winemartvn.com/api/uploads/posts/284b35e03695e356638bae8412da037f.jpg\"></p><p><br></p><p>- Các showroom rượu vang: Những cửa tiệm lớn nhỏ, có trang web, fanpage … hoặc không. Ưu điểm lớn nhất của những cửa tiệm như thế này là họ có kiến thức về rượu, có thể đáp ứng phần nào những tò mò, thắc mắc của bạn về các loại rượu.</p><p>Tuy nhiên, nhược điểm khi mua rượu vang ở những cửa tiệm này đó là bạn phải đối mặt với một tỷ lệ hàng giả, hàng lỗi, hàng hỏng khá cao. Nhất là khi bạn là một người chưa có đủ kiến thức về các loại rượu vang.</p><p class=\"ql-align-center\"><img src=\"https://winemartvn.com/api/uploads/posts/2f60bbeb8110366a22d281177ba31c6d.jpg\"></p><p><br></p><p>- Những cá nhân bán lẻ tràn lan trên mạng: Đây là những đối tượng mà bạn tuyệt đối không nên tìm họ để mua rượu vang, trừ khi là người quen thân thiết, có thể tin tưởng được.</p><p>Giá cả cũng là một vấn đề bạn cần cân nhắc kĩ khi đi tìm câu trả lời cho câu hỏi: “<em>Mua rượu vang ở đâu là tốt nhất</em>”. Nếu giá rượu quá rẻ so với những thông tin mà bạn biết được, hãy cẩn thận vì rất nhiều trường hợp “<em>của rẻ là của ôi</em>”. Còn nếu giá rượu quá cao so với giá niêm yết của hãng sản xuất, bạn lại có thể an tâm hơn một chút. Vì rượu là loại hàng hoá bị đánh thuế tiêu thụ đặc biệt rất cao.</p><p>Vậy cuối cùng, bạn <strong>nên mua rượu vang ở đâu</strong> để có thể hoàn toàn an tâm về chất lượng, giá cả? Xét trên ba nhóm đối tượng phân phối rượu vang ở trên, bạn có thể nhận thấy việc mua rượu vang tại các siêu thị là một lựa chọn khả dĩ. Nếu có thể tìm được một siêu thị nào đó giữa thị trường xô bồ này có khả năng phân phối nhiều loại rượu vang và có thể tư vấn giúp bạn lựa chọn loại rượu phù hợp. Vấn đề mua rượu vang ở đâu sẽ được giải quyết một cách rất dễ dàng.</p><p><br></p><p class=\"ql-align-center\"><strong style=\"color: rgb(215, 35, 40);\">CHƯƠNG TRÌNH 10 CHAI MỖI THÁNG</strong></p><p class=\"ql-align-center\"><em>Từ 45.000.000 VNĐ/năm chỉ còn 35.000.000 VNĐ/năm</em></p><p class=\"ql-align-center\"><strong>Tặng kèm bộ quà tặng siêu hấp dẫn</strong></p><p class=\"ql-align-center\"><strong style=\"color: rgb(0, 0, 0);\">Đăng kí ngay:</strong>&nbsp;<a href=\"https://winemart.vn/10chaimoithang/\" rel=\"noopener noreferrer\" target=\"_blank\"><strong>https://winemart.vn/10chaimoithang/</strong></a></p><p class=\"ql-align-center\"><br></p><p class=\"ql-align-center\"><a href=\"tel:1900636035\" rel=\"noopener noreferrer\" target=\"_blank\"><img src=\"https://winemartvn.com/api/uploads/posts/111071c6ac391fef8364312e8f8ab7c8.jpg\"></a></p><p class=\"ql-align-center\"><br></p><p class=\"ql-align-center\"><a href=\"https://m.me/892273407528616\" rel=\"noopener noreferrer\" target=\"_blank\"><img src=\"https://winemartvn.com/api/uploads/posts/cd9a1510d07db065c2f9636f79725df8.jpg\"></a></p><p class=\"ql-align-center\"><br></p><p class=\"ql-align-center\"><br></p>",
//     "excerpt": null,
//     "type": null,
//     "permalink": null,
//     "imageTitle": null,
//     "imageCaption": null,
//     "imageDescription": null,
//     "imageAltText": null,
//     "imageFeatured": "78af9b70d0763447d5b1dd8f69792cd2.jpg",
//     "tags": "string",
//     "prominentWords": null,
//     "authorId": "fd309657-4aee-4fb5-886b-7d2acfcc5811",
//     "createdBy": "fd309657-4aee-4fb5-886b-7d2acfcc5811",
//     "slugs": [
//       "string-123"
//     ],
//     "status": "publish",
//     "format": null,
//     "template": null,
//     "parent": null,
//     "parentSlug": null,
//     "order": null,
//     "commentStatus": null,
//     "pingStatus": null,
//     "metaDescription": "string",
//     "timePublication": "2020-12-24T04:47:25.000Z",
//     "shortDescription": null,
//     "createdAt": "2020-12-24T04:47:25.358Z",
//     "categoryBlog": {
//       "id": "a5e808f3-5d1d-4748-92a9-14261b0cefe1",
//       "picture": null,
//       "name": "Tin tức",
//       "parentId": null,
//       "description": null,
//       "slug": "tin-tuc",
//       "isHaveChildren": false,
//       "status": true
//     },
//     "author": {
//       "id": "fd309657-4aee-4fb5-886b-7d2acfcc5811",
//       "email": "son@gmail.com",
//       "password": "$2a$10$v7zvrxKGaT/Ievk7gyyv6uHK8rShV2jv3s0NTQ/0xIF73MLzSIcuG",
//       "roleId": "daa525fb-be32-4923-929b-033d75545205",
//       "fullName": "Son Nguyen",
//       "phone": "0332176333",
//       "gender": 1,
//       "avatar": null
//     }
//   }
